import {
  Duration,
  add,
  min,
  max,
  isBefore,
  isEqual,
  differenceInSeconds,
  minutesToSeconds,
  hoursToSeconds,
  isValid,
} from "date-fns";

const HOURS_IN_DAYS = 24;

const daysToSeconds = (days: number): number => {
  return hoursToSeconds(days * HOURS_IN_DAYS);
};

const durationToSeconds = (duration: Duration): number => {
  return (
    daysToSeconds(duration.days || 0) +
    hoursToSeconds(duration.hours || 0) +
    minutesToSeconds(duration.minutes || 0) +
    (duration.seconds || 0)
  );
};

export const getTick = (rangeDate: [Date, Date], duration: Duration, tickIndex: number): Date => {
  const step = Object.keys(duration).reduce(
    (durationMultiplier, intervalKey) => ({ ...durationMultiplier, [intervalKey]: duration[intervalKey] * tickIndex }),
    {} as Duration,
  );

  // TODO refactor it
  return max([min([add(rangeDate[0], step), rangeDate[1]]), rangeDate[0]]);
};

export const getNextTick = (rangeDate: [Date, Date], duration: Duration, tick): Date => {
  return min([add(tick, duration), rangeDate[1]]);
};

export const getTicks = (rangeDate: [Date, Date], duration: Duration): Date[] => {
  if (isBefore(rangeDate[1], rangeDate[0]) || !isValid(rangeDate[0]) || !isValid(rangeDate[1])) {
    return [];
  }

  let currentStep = rangeDate[0];
  const ticks = [];

  while (isBefore(currentStep, rangeDate[1])) {
    ticks.push(currentStep);
    currentStep = min([add(currentStep, duration), rangeDate[1]]);
  }

  if (isEqual(currentStep, rangeDate[1])) {
    ticks.push(currentStep);
  }

  return ticks;
};

export const getTickCount = (rangeDate: [Date, Date], duration: Duration): number => {
  if (isBefore(rangeDate[1], rangeDate[0])) {
    return 1;
  }

  if (duration.years || duration.months) {
    return getTicks(rangeDate, duration).length;
  }

  return Math.ceil(differenceInSeconds(rangeDate[1], rangeDate[0]) / durationToSeconds(duration)) + 1;
};
